<template>
    <div component="ProjectActorDialogInfo">
        <div class="holder">
            <div class="cell ratings">
                <h3>Ratings:</h3>
                <div class="left">
                    <div class="line">
                        <div class="name">
                            <tooltip-question :text="'How many times have clients listened to this voice.'" />
                            RATING:
                        </div>
                        <div class="value">{{ rating.pocet_klikov }}</div>
                    </div>
                    <div class="line">
                        <div class="name">
                            <tooltip-question :text="'How many times was this voice approved for Recording.'" />
                            WIN:
                        </div>
                        <div class="value">{{ rating.pocet_vitazstiev }}</div>
                    </div>
                </div>

                <div class="right">
                    <div class="line">
                        <div class="name">
                            <tooltip-question :text="'How many times was this voice nominated for shortlist.'" />
                            SHORTLIST:
                        </div>
                        <div class="value">{{ rating.pocet_vyberov }}</div>
                    </div>
                    <div class="line">
                        <div class="name">
                            <tooltip-question :text="'Position in TOP 30 most wanted voices.'" />
                            TOP 30:
                        </div>
                        <div class="value">{{ rating.top_30_filtered }}</div>
                    </div>
                </div>
            </div>
            <!--            <div class="cell prices">-->
            <!--                <h3>Prices:</h3>-->
            <!--                <div class="line" v-for="price in pricesView" :key="price.id">-->
            <!--                    <div class="name">{{ price.type }}:</div>-->
            <!--                    <div class="value">{{ price.price }}&nbsp;€</div>-->
            <!--                </div>-->
            <!--            </div>-->
        </div>

        <project-actor-dialog-portfolio :actor="actor" />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Mp3Player from '@/components/.global/Mp3Player';
import ProjectActorDialogPortfolio from './ProjectActorDialogPortfolio';
import TooltipQuestion from '@/components/.global/TooltipQuestion';

export default {
    name: 'ProjectActorDialogInfo',

    components: { TooltipQuestion, ProjectActorDialogPortfolio, Mp3Player },

    props: {
        actor: {
            type: Object,
            required: true,
        },
    },

    methods: {
        ...mapActions(['loadNominations']),
    },

    computed: {
        ...mapGetters(['getProjectType']),

        rating() {
            return this.actor?.rating ?? {};
        },

        pricesView() {
            return (
                this.actor.prices?.map((item) => {
                    const type = this.getProjectType(item.id_typ_diela);
                    return {
                        type: type?.nazov ?? '',
                        price: (item.price && item.price.toFixed(2)) || type?.cena || '',
                    };
                }) ?? {}
            );
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='ProjectActorDialogInfo'] {
    .flex-column;
    align-items: flex-start;
    padding: 25px;
    width: 100%;
    height: 100%;

    .holder {
        width: 100%;
        display: flex;
    }

    .cell {
        min-width: 180px;

        h3 {
            margin-top: 0;
        }

        &.prices {
            margin-left: 25px;
            padding-top: 10px;
        }

        &.ratings {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            background-color: @white;
            padding: 15px;
            .radius;

            .left,
            .right {
                width: 50%;
            }

            .right {
                padding-left: 20px;
            }

            h3 {
                width: 100%;
            }
        }
    }

    .line {
        .flex-row;
        padding: 1px 0;

        .name {
            margin-right: 7px;
            display: flex;
            align-items: center;

            div {
                margin-right: 5px;
            }
        }

        .value {
            font-weight: bold;
        }
    }
}
</style>
